import { IconName } from './icons.type';

export type NestedIcon = { [key: string]: IconName } & { default: IconName };
export const keyIconMap = <T extends Record<string, IconName | NestedIcon>>(v: T): T => v;
